import { User, Share2, Shield } from 'lucide-react';
import { defineSchema } from '@shared/search';

export const teamSharingSchema = defineSchema({
  id: 'team-sharing',
  title: 'filter.schema.teamSharing.title',
  subtitle: 'filter.schema.teamSharing.subtitle',
  defaultField: 'owner',
  fields: {
    owner: {
      key: 'owner',
      label: 'filter.field.ownerName',
      type: 'text',
      icon: User,
      placeholder: 'filter.placeholder.driver',
      description: 'filter.desc.ownerName',
      example: 'owner:Yanick',
    },
    type: {
      key: 'type',
      label: 'filter.field.shareScope',
      type: 'enum',
      icon: Share2,
      allowMultiple: true,
      description: 'filter.desc.shareScope',
      options: [
        { value: 'all', label: 'filter.shareScope.all' },
        { value: 'single', label: 'filter.shareScope.single' },
        { value: 'track', label: 'filter.shareScope.track' },
      ],
      example: 'type:all',
    },
    role: {
      key: 'role',
      label: 'filter.field.role',
      type: 'enum',
      icon: Shield,
      allowMultiple: true,
      description: 'filter.desc.role',
      options: [
        { value: 'manage', label: 'team.role.manage' },
        { value: 'read', label: 'team.role.read' },
      ],
      example: 'role:read',
    },
  },
  examples: [
    { q: 'Yanick', desc: 'filter.example.sharesYanick' },
    { q: 'type:all role:read', desc: 'filter.example.sharesAllRead' },
  ],
});

